import { render } from "./Lojas.vue?vue&type=template&id=703718e2&scoped=true"
import script from "./Lojas.vue?vue&type=script&lang=js"
export * from "./Lojas.vue?vue&type=script&lang=js"

import "./Lojas.vue?vue&type=style&index=0&id=703718e2&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703718e2"]])

export default __exports__